import { styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import React from "react";

interface LightTooltipProps extends TooltipProps {
  width?: number;
}

export const LightTooltip = styled(({ className, ...props }: LightTooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
  />
))(({ theme, width }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,

    ...(width && {
      width: `${width}px !important`,
      maxWidth: `${width}px !important`,
      minWidth: `${width}px !important`,
    }),
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
}));

interface CustomTooltipProps extends TooltipProps {
  tooltipStyles?: React.CSSProperties;
}

export const CustomTooltip = styled(({ className, tooltipStyles, ...props }: CustomTooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
  />
))(({ tooltipStyles }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    ...(tooltipStyles && tooltipStyles),
  },
}));
